import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import track from 'c9-tracking';
import { RECEIPT_PATH } from '../constants';
import { IState, Submission } from '../types';
import log from '../utils/logger';
import { NavigationState } from './navigation.type';

export const submit = createAsyncThunk<void, void, { state: IState }>('navigation/submit', async (_, thunkAPI) => {
  const state = thunkAPI.getState();

  const {
    navigation,
    settings: {
      appName,
      endpointConfig: { apiAwsBase: host },
    },
  } = state;

  const payload = createSubmissionPayload(navigation);

  const response = await axios({
    method: 'POST',
    url: `${host}/ninjas-write-to-us-api-v2/v1/submission/${navigation.topic}`,
    headers: {
      'Content-Type': 'application/json',
      'x-top-appname': appName,
    },
    data: JSON.stringify(payload),
  });

  if (response.status / 100 !== 2) {
    throw new Error(`Status: ${response.status}, message: ${await response.data}`);
  }

  const submission: Submission = {
    topic: navigation.topic,
    name: navigation.name,
    email: navigation.email,
    mobile: navigation.mobile,
  };

  track.convert([
    {
      key: 'topic',
      value: submission.topic,
    },
  ]);

  try {
    saveToSession(submission);
    window.location.href = RECEIPT_PATH;
  } catch (e) {
    log.warn(`Session storage is not supported, falling back to querystring : `, e, submission);

    // pass the details required by receipt page in the form of query string
    window.location.href = `${RECEIPT_PATH}?${Object.entries(submission)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')}`;
  }
});

const createSubmissionPayload = (state: NavigationState): {} => ({
  name: state.name,
  email: state.email,
  mobile: state.mobile,
  message: state.message,
});

const saveToSession = (submission: Submission) => {
  window.sessionStorage.setItem('write-to-us-submission', JSON.stringify(submission));
};
